<template>
  <div>
    <div >
      <div v-for="(activeCountrySection) in activeCountrySections">
        <div class="container">
          <div class="geo-news-title flex items-center" style="padding-left:0"  v-if="showActiveLanguage(activeCountrySection)">
            <div>
              <h2 class="featured-news mt-0 sm:mt-4">Featured News</h2>
            </div>
            <div v-if="isDualLanguage(activeCountrySection)" class="switch-wrapper news feature">
              <switch-tw class="switch-tw" @toggle="toggle" :active="toggleEnabled" :options="['English', 'French']"></switch-tw>
            </div>
            <div class="ml-auto geo-news-link">
              <a :href="activeCountrySection.geoPath" class="all-geo-news">{{activeCountrySection.section_label ? activeCountrySection.section_label : 'All ' + activeCountrySection.name + ' News'}}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="automation-news-articles section-articles news-list" role="" data-country="">
        <div class="featured-articles-wrapper" v-for="(activeCountrySection) in activeCountrySections">
          <article-featured :article="featuredArticle"  v-if="showActiveLanguage(activeCountrySection)"></article-featured>
          <div class="grid grid-cols-1 md:grid-cols-3"  v-if="showActiveLanguage(activeCountrySection)">
            <article-item v-for="(article) in activeCountrySection.articles.slice(1, 4)" v-bind:key="article.id" :article="article" :country="activeCountrySection.name"></article-item>
          </div>
        </div>

        <div v-for="(countrySection) in countrySections">
          <div class="country-section-wrapper" v-if="showActiveLanguage(countrySection)">
            <div class="geo-news-title geo-news-title flex items-center sm:mt-[60px]" style="padding-left: 0">
              <div>
                <h4 style="margin-left: 0;">{{countrySection.name}}</h4>
              </div>
              <div v-if="isDualLanguage(countrySection)" class="switch-wrapper news">
                <switch-tw @toggle="toggle" :active="toggleEnabled" :color="'#0157FF'" :options="['English', 'French']"></switch-tw>
              </div>
              <div class="ml-auto">
                <a :href="countrySection.geoPath" class="all-geo-news">{{countrySection.section_label ? countrySection.section_label : 'All ' + countrySection.name + ' News'}}</a>
              </div>
            </div>

            <div class="grid-col-3  feature-list">
              <div v-for="(article) in countrySection.articles.slice(0, 3)">
                <article-item :article="article" :country="countrySection.name" :force-class="true"></article-item>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'articles-global',
  props: {
    articles: {
      required: true,
    },
  },
  computed: {
    activeRegionCode: function(){
      const element = document.querySelector('html').getAttribute('data-ipcountry');
      let code = !element ? 'gb' : (element === 'en-GB' ? 'gb' : element.toLowerCase());

      const validCode = this.data.find(item => item.code === code);
      if (!validCode) {
        code = 'gb';
      }
      return code;
    },
    data: function(){
      return Object.keys(this.articles).map(key => {
        return this.articles[key];
      });
    },
    countrySections: function(){
      // return this.data.filter(item => item.code !== this.activeRegionCode).sort((a, b) => a.name.localeCompare(b.name));
      const codes = ['ca', 'ca-fr'].includes(this.activeRegionCode) ? ['ca', 'ca-fr'] : [this.activeRegionCode];
      return this.data.filter(item => !codes.includes(item.code)).sort((a, b) => a.name.localeCompare(b.name));
    },
    activeCountrySections: function() {
      if (this.activeRegionCode === 'ca-fr') {
        this.toggleEnabled = true;
      }
      if (['ca', 'ca-fr'].includes(this.activeRegionCode)) {
        const d = this.data.filter(item => ['ca', 'ca-fr'].includes(item.code));
        return d;
      }

      return this.data.filter(item => item.code === this.activeRegionCode);
    },
    featuredArticle: function() {
      if (this.activeCountrySections.length > 1) {
        if (this.toggleEnabled) {
          return this.activeCountrySections.find(item => item.language === 'French').articles[0];
        } else {
          return this.activeCountrySections.find(item => item.language === 'English').articles[0];
        }

      }
      return this.activeCountrySections[0].articles[0];
    },
  },
  data() {
    return {
      toggleEnabled: false,
      dualLanguageMapping: {
        'ca': 'ca-fr'
      }
    };
  },
  methods: {
    toggle: function(state) {
      this.toggleEnabled = state;
      return '';
    },
    isDualLanguage: function(item) {
      return item.code === 'ca' || item.code === 'ca-fr';
    },
    showActiveLanguage: function(item) {
      if (!this.isDualLanguage(item)) return true;
      if (!this.toggleEnabled && item.language === 'English') {
        return true;
      }
      return this.toggleEnabled && item.language === 'French';
    },
  },
};
</script>
<style>
@media (max-width: 500px) {
  .featured-news {
    margin-top: 0!important;
  }
  .switch-wrapper.news {
    position: absolute;
    right: 0;
    margin-top: 60px;
  }
  switch-wrapper.news .switch-tw {
    margin-top: 2em;
  }
  .switch-wrapper.feature {
    margin-top: 40px;
  }
  .geo-news-title:has(.switch-wrapper) {
    margin-bottom: 30px;
  }
  .geo-news-link {
    margin-bottom: 20px;
  }
}

</style>
